import { HeroUIProvider } from '@heroui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// eslint-disable-next-line import/no-unresolved
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import Application from './components/Application';
import ReduxProvider from './components/ReduxProvider';

import { queryClient } from '~/api/queryClient';

const ReactQueryDevtoolsProduction = lazy(() =>
  // eslint-disable-next-line import/no-unresolved, import/extensions
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    d => ({
      default: d.ReactQueryDevtools
    })
  )
);

function App() {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    // @ts-expect-error - window.toggleDevtools is not typed
    window.toggleDevtools = () => setShowDevtools(old => !old);
  }, []);

  return (
    <HeroUIProvider>
      <QueryClientProvider client={queryClient}>
        <NuqsAdapter>
          <BrowserRouter>
            <ReduxProvider>
              <Application />
            </ReduxProvider>
          </BrowserRouter>
        </NuqsAdapter>
        {process.env.NODE_ENV === 'development' ? (
          <ReactQueryDevtools initialIsOpen={false} />
        ) : (
          showDevtools && (
            <Suspense fallback={null}>
              <ReactQueryDevtoolsProduction />
            </Suspense>
          )
        )}
      </QueryClientProvider>
    </HeroUIProvider>
  );
}

export default App;
